"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BoxLead;

var _react = _interopRequireWildcard(require("react"));

var _counter = _interopRequireDefault(require("../counter"));

var _contexts = require("../app/contexts");

var _helpers = require("./helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function BoxLead(_ref) {
  let {
    onClick,
    isExpanded
  } = _ref;
  const {
    totalContents
  } = (0, _react.useContext)(_contexts.Storage);
  const {
    strings
  } = (0, _react.useContext)(_contexts.Settings);
  const leadStr = (0, _helpers.strOrFunc)(strings.lead, [totalContents]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `donation-encourager__lead`,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "donation-encourager__headline"
  }, /*#__PURE__*/_react.default.createElement(_counter.default, {
    value: totalContents
  })), /*#__PURE__*/_react.default.createElement("p", {
    className: "donation-encourager__lead-text"
  }, /*#__PURE__*/_react.default.createElement("small", null, leadStr, isExpanded ? " ↑" : " ↓")));
}
/*
        <button
          className="donation-encourager__collapser"
          onClick={onClick}
          aria-expanded={isExpanded}
        >
          <small>
            {isExpanded ? "Weniger Informationen ↑" : "Mehr Informationen ↓"}
          </small>
        </button>
*/